import { zSchema } from "@zeal/common";

export const getSshKeyRotationTestConnectionRequestSchema = zSchema.object({
  state_code: zSchema.string().min(1),
});

export type TGetSshKeyRotationTestConnectionRequestSchema = zSchema.infer<
  typeof getSshKeyRotationTestConnectionRequestSchema
>;

export const getSshKeyRotationTestConnectionResponseSchema = zSchema.object({
  success: zSchema.boolean(),
  message: zSchema.string().optional(),
});

export type TGetSshKeyRotationTestConnectionResponseSchema = zSchema.infer<
  typeof getSshKeyRotationTestConnectionResponseSchema
>;
